module.exports = __webpack_public_path__ + "img/avatar1.2c3ec23d.png";